import { render, staticRenderFns } from "./ActivityTab.vue?vue&type=template&id=5304634f&scoped=true&"
import script from "./ActivityTab.vue?vue&type=script&lang=js&"
export * from "./ActivityTab.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTab.vue?vue&type=style&index=0&id=5304634f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304634f",
  null
  
)

export default component.exports